import React from "react";
import TopNavbar from "../components/navigation/TopNavbar";
import Footer from "../components/utilities/Footer";

const GuestLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <TopNavbar />
      <main className="flex-grow overflow-x-hidden">{children}</main>
      <Footer />
    </div>
  );
};

export default GuestLayout;
